// Form validation constants for application-for.vue
// They have to match database field limits
export const MAX_PHONE_LENGTH = 13;
export const MAX_NAME_LENGTH = 255;

// Address is stored in one field of 255 chars in the database, sum of following should not exceed that
export const MAX_CITY_LENGTH = 100;
export const MAX_STREET_LENGTH = 100;
export const MAX_ZIP_LENGTH = 10;
export const MAX_STREET_NUMBER_LENGTH = 10;
